module.exports = __webpack_public_path__ + "img/amblem1.60a2117e.svg";